import React, { FC } from 'react';
import { FieldHelper } from 'utils/field';
import { MultiSelectField, MultiUserField } from '../fields';
import { MultiSelectFieldFilter } from '../filters/multi-select';
import { MultiUserFieldFilter } from '../filters/multi-user';
import { SelectFilterOperationType } from '../filters/select';
import { EditorComponents, TagEditorComponents } from './editor-components';
import { MultiSelectBaseCriteria } from './multi-select-base';

interface Props {
  filter: MultiSelectFieldFilter;
  components?: EditorComponents;
  onChange: (filter: MultiSelectFieldFilter) => void;
  getFilterOperationTypeOptions?: (
    field: MultiUserField | MultiSelectField,
  ) => MultiUserFieldFilter[] | MultiSelectFieldFilter[];
  getOperationOptionRenderer?: (
    type: SelectFilterOperationType,
  ) => null | JSX.Element;
}

export const MultiSelectCriteria: FC<Props> = ({
  filter,
  onChange,
  components,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
}) => (
  <MultiSelectBaseCriteria
    components={{
      ...TagEditorComponents,
      ...components,
    }}
    filter={filter}
    onChange={onChange as any}
    options={FieldHelper(filter.field).options.activeOptions}
    getFilterOperationTypeOptions={getFilterOperationTypeOptions}
    type="tag"
    getOperationOptionRenderer={getOperationOptionRenderer}
  />
);
